//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TableColumn } from '@/redux/slices/slice_types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DraggableColumnContent from './DraggableColumnContent';

export type DraggableColumnProps = {
  sectionKey: string;
  checked: boolean;
  label: TableColumn['label'];
  index: number;
  handleChange?: (index: number, checked: boolean) => void;
  isOver?: boolean;
  id: string;
};

const DraggableColumn = (props: DraggableColumnProps) => {
  const { checked, label, index, id, sectionKey } = props as DraggableColumnProps;
  const { attributes, listeners, setNodeRef, transform, transition, active, over, isDragging } = useSortable({
    animateLayoutChanges: (e) => {
      return e.isDragging || e.isSorting;
    },
    transition: {
      duration: 250,
      easing: 'ease-in-out'
    },
    id,
    data: { index, label, checked }
  });

  const style = {
    cursor: 'grab',
    opacity: isDragging ? 0 : sectionKey === over?.data?.current?.sortable?.containerId && id !== active?.id ? 0.5 : 1,
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <DraggableColumnContent {...props} />
    </div>
  );
};

export default DraggableColumn;
